
function SeedInputController($scope, TranslationService) {
    var ctrl = this;

    ctrl.$onInit = function () {
        //console.log('onInit ' + ctrl.numRows);
        if (!ctrl.numRows) {
            ctrl.numRows = 2;
        }
    };

    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.copy = function (text) {
        if (window.clipboardData && window.clipboardData.setData) {
            return clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            } catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    };

    ctrl.inputChanged = function () {
        //Zera msg se existir
        //console.log('inputChanged ' + ctrl.name);
        if (ctrl.formEditing && ctrl.name) {
            ctrl.formEditing[ctrl.name].$setValidity("required", true);
        }
    };

    ctrl.selectItem = function (item) {
        //console.log('sd-input.selectItem');
        ctrl.modelId = item.Key;
        //model = item.Value;

        ctrl.onSelectItem({ item: item });
    };

    //ctrl.onSelectItem = function (item) {
        
    //};

}

SeedInputController.$inject = ['$scope', 'TranslationService'];

seedWebApp.component('sdInput', {
    controller: SeedInputController,
    bindings: {
        name: '@',
        inputType: '<',         // Tipos (text, date, switch, select, btn-group, link, debounce, typeahead, checkbox, number, textarea, flag)
        options: '<',           // Modelo (Key, Value)
        label: '<',             // Label do input
        model: '=',             // Modelo à ser alterado
        modelId: '=',           // ID do modelo
        disabled: '<',          // Define se campo está desabilitado para edição
        typeaheadService: '<',  // Serviço que trás valores para Typeahead
        selectItem: '<',        // Função que é ativada ao selecionar valor no Typeahead ou select
        debounce: '=',          // Função ativada no debounce do input
        required: '=',          // Define se o input é necessário ou não, o circulando de vermelho caso esteja vazio
        placeholder: '<',        // Texto no campo
        formEditing: '<',
        numRows: '<',
        fontFamily: '<',
        onSelectItem: '&'
    },
    templateUrl: '/SPA/Components/sd-input.html' + seedWebApp.buildVersion
});
